import React from 'react'
import {EnrollmentReasonInfo} from '../../../DTO/BucketHeader'
import {EnrollmentReasonSelectedInfo} from '../InputContentBlocks/EnrollmentReasonSelectContentBlock'
import {PIMCard} from '../../Atoms/Cards/PIMCard'
import {MBListItem, MBUnorderedList} from '../../Atoms/Lists/MBList'
import {MBContentBodyTypography} from '../../Atoms/Typographies'
import {Optional} from '../../../../Common/TypeHelper'
import {Spacer} from '../../../../Common/Components/Spacer'
import {PIMStack} from '../../Atoms/Layouts/Bases/PIMStack'
import {useTranslation} from 'react-i18next'

type EnrollmentReasonConfirmContentBlockProps = {
  enrollmentReasonInfoList: Optional<EnrollmentReasonInfo[]>
  enrollmentReasonSelectedInfo: Optional<EnrollmentReasonSelectedInfo>
}
export const EnrollmentReasonConfirmContentBlock:
  React.VFC<EnrollmentReasonConfirmContentBlockProps> = (
  {
    enrollmentReasonInfoList,
    enrollmentReasonSelectedInfo,
  },
) => {
  const {t} = useTranslation('member')

  if (!enrollmentReasonInfoList
    || enrollmentReasonInfoList.length === 0
    || !enrollmentReasonSelectedInfo) {
    return <></>
  }

  const getEnrollmentReasonInfo = enrollmentReasonInfoList.find(enrollmentReasonInfo =>
    enrollmentReasonInfo.id ===
    enrollmentReasonSelectedInfo.enrollmentReasonId,
  )

  return (
    <Spacer mb={'16px'}>
      <PIMStack alignItems={'center'}>
        <PIMCard
          headerProps={{title: t('新規登録情報確認.入会動機.見出し')}}
          testId={'block-enrollment-reason-confirm'}
          pb={'20px'}
        >
          <MBUnorderedList>
            <MBListItem>
              <MBContentBodyTypography>
                {getEnrollmentReasonInfo?.label ?? ''}
              </MBContentBodyTypography>
            </MBListItem>
          </MBUnorderedList>
        </PIMCard>
      </PIMStack>
    </Spacer>
  )
}
